import { EntityInput, forCreate, forDelete, forUpdate } from '../common/entity';
import { ProductExportConfiguration } from './productExportConfiguration';

export class ProductExportConfigurationInput
  extends ProductExportConfiguration
  implements EntityInput<ProductExportConfiguration>
{
  forCreate(): CreateProductExportConfigurationInput {
    return CreateProductExportConfigurationInput.from(
      { ...this, mapping: Object.fromEntries(this.mapping) },
      CreateProductExportConfigurationInput,
    );
  }

  forUpdate(): UpdateProductExportConfigurationInput {
    return UpdateProductExportConfigurationInput.from(
      { ...this, mapping: Object.fromEntries(this.mapping) },
      UpdateProductExportConfigurationInput,
    );
  }

  forDelete(): DeleteProductExportConfigurationInput {
    return DeleteProductExportConfigurationInput.from(this, DeleteProductExportConfigurationInput);
  }
}

export class CreateProductExportConfigurationInput extends forCreate(ProductExportConfiguration) {}

export class UpdateProductExportConfigurationInput extends forUpdate(ProductExportConfiguration) {}

export class DeleteProductExportConfigurationInput extends forDelete(ProductExportConfiguration) {}
